import React, { useState } from 'react';

export function fecharGuiaFatura(guia) {
  if (guia && !guia.closed) guia.close();
}

export function reservarGuiaFatura() {
  let guia;
  try {
    // Reserve durante o clique, antes das consultas e da geração da cobrança.
    guia = window.open('', '_blank');
    if (guia) {
      guia.opener = null;
      guia.document.title = 'Preparando fatura';
      guia.document.body.textContent = 'Estamos preparando sua fatura. Aguarde nesta guia.';
    }
    return guia;
  } catch {
    fecharGuiaFatura(guia);
    return null;
  }
}

export default function useFaturaNovaGuia() {
  const [linkParaAbrir, setLinkParaAbrir] = useState('');

  function abrirFaturaNovaGuia(link, guia = reservarGuiaFatura()) {
    const url = new URL(String(link || '').trim());
    if (url.protocol !== 'https:') throw new Error('O link da fatura não é válido.');

    if (guia && !guia.closed) {
      try {
        guia.location.replace(url.href);
        setLinkParaAbrir('');
      } catch {
        fecharGuiaFatura(guia);
        setLinkParaAbrir(url.href);
      }
    } else {
      // Reautenticação ou bloqueio de pop-ups podem impedir a reserva da guia.
      setLinkParaAbrir(url.href);
    }
  }

  const modalFatura = linkParaAbrir ? (
    <div style={{ position: 'fixed', inset: 0, backgroundColor: 'rgba(15, 23, 42, 0.38)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px', zIndex: 9998 }}>
      <div role="dialog" aria-modal="true" aria-labelledby="titulo-fatura-pronta" className="panel-compact-dialog" style={{ width: '100%', maxWidth: '420px', backgroundColor: '#fff', boxShadow: '0 20px 45px rgba(0,0,0,0.18)', textAlign: 'center' }}>
        <h3 id="titulo-fatura-pronta">Sua fatura está pronta</h3>
        <p>O navegador não abriu a nova guia automaticamente. Use o botão abaixo para abrir a fatura sem sair do painel.</p>
        <div className="routine-actions" style={{ justifyContent: 'center', flexWrap: 'wrap' }}>
          <a className="routine-btn routine-btn--primary" href={linkParaAbrir} target="_blank" rel="noopener noreferrer">Abrir fatura em nova guia</a>
          <button type="button" className="routine-btn routine-btn--soft" onClick={() => setLinkParaAbrir('')}>Fechar</button>
        </div>
      </div>
    </div>
  ) : null;

  return { abrirFaturaNovaGuia, modalFatura };
}
